module.exports = __webpack_public_path__ + "img/person-contact.706c9077.svg";